import { jsx as _jsx } from "react/jsx-runtime";
import { Children, isValidElement, memo, useLayoutEffect, useMemo } from 'react';
import { useMediaQuery } from 'react-responsive';
import { Media } from '../../../../../theme/Media';
import { DATA_ATTR_TABLE_HEADROW, SPECIAL_CONTENT_TYPES } from '../../constants';
import { useTableContext } from '../../context';
import { TableCellContentType } from '../../types';
import { HeadRowWrapper, HeadRowInner } from './styled';
const DEFAULT_COLUMN = 'minmax(min-content, 1fr)';
function getColumnSize(props) {
    if (props.column)
        return props.column;
    if (props.contentType && SPECIAL_CONTENT_TYPES.has(props.contentType))
        return 'auto';
    return DEFAULT_COLUMN;
}
export const HeadRow = memo(function HeadRow({ children, className }) {
    const { inner, registerColumns } = useTableContext();
    const isMobile = useMediaQuery({ query: Media.xsMax });
    const columnMeta = useMemo(() => {
        const validChildren = Children.toArray(children).filter(isValidElement);
        const columnSizes = [];
        let hasDnd = false;
        let hasCheckbox = false;
        let hasAction = false;
        for (const child of validChildren) {
            const props = child.props;
            columnSizes.push(getColumnSize(props));
            if (props.contentType === TableCellContentType.DND)
                hasDnd = true;
            if (props.contentType === TableCellContentType.CHECKBOX)
                hasCheckbox = true;
            if (props.contentType === TableCellContentType.ACTION)
                hasAction = true;
        }
        return { columns: columnSizes.join(' '), hasDnd, hasCheckbox, hasAction };
    }, [children]);
    // Register columns before the mobile early-return below, so columnCount stays correct even when
    // the header itself isn't rendered on mobile (Loader and SubRow rely on it for their layout).
    useLayoutEffect(() => {
        registerColumns(columnMeta);
    }, [columnMeta, registerColumns]);
    if (isMobile && !columnMeta.hasCheckbox)
        return null;
    return (_jsx(HeadRowWrapper, { className: className, "$inner": inner, role: 'presentation', [DATA_ATTR_TABLE_HEADROW]: inner ? 'inner' : 'true', children: _jsx(HeadRowInner, { role: 'row', children: children }) }));
});
